import { Controller } from "@hotwired/stimulus"

// Provides radio-like behavior for a group of checkboxes:
// - Clicking an unchecked input checks it and unchecks all siblings.
// - Clicking an already-checked input unchecks it
export default class extends Controller {
  static targets = ["input"]

  toggle(event) {
    const clicked = event.currentTarget
    const wasChecked = !clicked.checked

    this.inputTargets.forEach(input => { input.checked = false })

    if (!wasChecked) {
      clicked.checked = true
    }
  }
}
